module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ctl",
    attrs: {
      "id": "d12e190"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Rola_1595552685_epub_c7_r1#d12e134",
      "id": "d12e191"
    }
  }, [_c('i', [_vm._v("chapter 1")]), _c('br'), _c('br'), _vm._v(" EDGE OF DISASTER")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0010_003",
      "id": "d12e197",
      "src": "images/9781595552686_ePDFnf_0010_003.jpg"
    }
  })]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e198"
    }
  }, [_c('b', [_vm._v("July 4, 2005, Riverfront Park, Nashville, Tennessee")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e201"
    }
  }, [_c('span', {
    staticClass: "dcap",
    attrs: {
      "id": "d12e202"
    }
  }, [_c('i', [_vm._v("F")])]), _vm._v("or years Diamond Rio managed to keep its internal issues a little-known secret.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e206"
    }
  }, [_vm._v("As members of the legendary Grand Ole Opry and strong examples of musical craftsmanship, the band’s six musicians had made a collective mark as a conglomeration of exacting players and sturdy personalities. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e208"
    }
  }, [_vm._v("Now, on a 2005 Fourth of July stage, the secret was literally out in the open, broadcast to a national TV audience. The band that owned a reputation as a fine-tuned hit-making machine was sputtering, and it took just three songs to send the message.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e210"
    }
  }, [_vm._v("Emcee Storme Warren introduced Diamond Rio to tens of thousands of fans along the Cumberland River that day as an act with a reputation for being “meticulous.” But the sound that emanated from the television speakers at home and at Nashville’s Riverfront Park—during GAC’s (Great American Country) "), _c('i', [_vm._v("Music City Independence Day Concert Spectacular")]), _vm._v("—failed to match the description. It was neither meticulous nor spectacular.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e215"
    }
  }, [_vm._v("Lead singer Marty Roe clawed at the notes during the verses, arching his eyebrows with each phrase in the music, an attempt to seemingly will every passage into pitch. He missed the mark, however, more often than he hit it. It was uncomfortable to hear, practically an advertisement to the viewers at home to turn to another station.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e217"
    }
  }, [_vm._v("As a listener, it was easy to write off the poor performance to sound problems—especially after the first song, “Beautiful Mess.” As Marty introduced the next number, bass player Dana Williams motioned frantically to someone offstage to make adjustments in his monitor. Perhaps the guys just weren’t hearing themselves properly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e219"
    }
  }, [_vm._v("But changing audio settings didn’t help. As the group plowed through the rest of the set, the sound continued to deteriorate, particularly during the choruses when Diamond Rio’s scintillating harmonies should have been at their most distinguished. Instead of the edgy, classy blend that had become their signature, the vocals were an amateurish collision. Marty and Dana were wishy-washy at best, and mandolin player Gene Johnson—whose tenor gave the harmonies their high-lonesome, quasi-bluegrass texture—seemed lost and out of place in the stratosphere.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e221"
    }
  }, [_vm._v("The band members forged on bravely, keeping their emotions in check and playing to the cameras as if nothing was wrong. But it was difficult. It was the first time they’d played a date in Nashville in years. This was an all-American gig in front of their neighbors, and they were blowing it. They had friends and family who’d come out just to see them, the crowd was dotted with fellow musicians and entertainment-business insiders, and they weren’t cutting it.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0012_002",
      "id": "d12e224",
      "src": "images/9781595552686_ePDFnf_0012_002.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e225"
    }
  }, [_c('b', [_c('i', [_vm._v("Left to Right")]), _vm._v(": Jimmy Olander, Gene Johnson, Marty Roe, Dana Williams. July 4, 2005, Riverfront Park, Nashville, Tennessee.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e230"
    }
  }, [_vm._v("“Trying to cowboy up during those three songs and make eye contact with people you know and love, it’s one of the most uncomfortable situations you’ll ever be in,” guitarist Jimmy Olander says.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e232"
    }
  }, [_vm._v("The show couldn’t end fast enough. It was bad. Most of them knew it. They hoped their reputation as pristine players and perfectionists would give them some leeway with the public. People hear what they want to hear, and they loved this band—six nice guys with heartland roots and a classic work ethic.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e234"
    }
  }, [_vm._v("Diamond Rio had launched twenty-five singles into the Top 20 on the "), _c('i', [_vm._v("Billboard ")]), _vm._v("country charts. The group had inspired fans with its joyous 1991 debut, “Meet in the Middle.” It had induced reflection with the 2001 ballad “One More Day,” adopted by many as a theme for personal commitment and later as a post–9/11 memorial to departed friends and family. The guys had cemented a place as sonic technicians with the intricate and inventive harmonies on 2002’s “Beautiful Mess.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e239"
    }
  }, [_vm._v("Playing a subpar concert in Music City was a tough pill to swallow. Some fans in the Fourth of July audience might overlook the pitch issues, but the band knew the professional musicians who were there could not. The Nashville Symphony had backed Diamond Rio during the concert, and now some of the town’s most astute players—many of whom probably knew the band’s name but perhaps not much of its work—likely suspected the group was a fake. And the pros in the country-music business, the people who knew the band’s history well, had now been alerted to the secret.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e241"
    }
  }, [_vm._v("Drummer Brian Prout stuck around after the performance to listen to Jamie O’Neal and Charlie Daniels and to watch the Independence Day fireworks. The crackling light display and the holiday’s patriotism lifted his spirits, but a familiar face put a miserable coda on the experience.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e243"
    }
  }, [_vm._v("Tim DuBois spotted Brian milling through the crowd at the end of the night and called out his name. Fifteen years earlier, Tim had been the head of Arista Records. He had signed Diamond Rio to its first record deal in 1990, had coproduced the group’s first six years of hits, and had given the guys an unusual degree of latitude. While most mainstream country bands are forced to sit on the sidelines while studio musicians play the instrumental parts on their sessions, Tim’s belief in Diamond Rio’s abilities had given them a unique position on Music Row. They were one of the few commercially successful bands that played exclusively on its own recordings, and that was historically one of the strengths of Diamond Rio’s live shows. The sound they got in the studio should have been replicated fairly well during the concert that day—but it was not. Tim knew something was wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e245"
    }
  }, [_vm._v("“Did you guys have trouble hearing on stage today or what?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e247"
    }
  }, [_vm._v("“Well, no,” Brian replied. “Actually, the sound was pretty decent.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e249"
    }
  }, [_vm._v("“Well, Marty didn’t hear worth a darn,” Tim said flatly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e252"
    }
  }, [_vm._v("Brian made a few excuses: Marty hadn’t been feeling well. The temperature at sound check had been around one hundred degrees, and maybe the humidity had affected the sound system’s responsiveness by the time the concert got under way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e254"
    }
  }, [_vm._v("Brian didn’t think Tim was buying the story, and frankly he’d grown weary of covering up. It wasn’t the first time Marty had sounded bad. In fact, he’d been singing poorly for at least three and a half years. As the drummer, Brian was the only band member who didn’t play a melodic instrument, and he’d mostly left it to the other guys to talk with their front man about the poor-quality performances they were delivering.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e256"
    }
  }, [_vm._v("Brian didn’t make any confessions to DuBois that Fourth of July, but the chance encounter “was the straw that broke the camel’s back,” Brian confesses. “Quite honestly, I postured myself as, "), _c('i', [_vm._v("Who am I to tell Marty Roe he can’t sing? ")]), _vm._v("That’d be like him comin’ to me and saying I don’t know how to play drums. So I kind of went up there and did my job and left him to Gene and Dana and maybe even to a large degree Jimmy and [keyboard player] Dan [Truman], who had a better understanding of the structure of melody and tone and notes than I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e261"
    }
  }, [_vm._v("But after years of mostly sitting back and staying out of it, Brian took the muzzle off. He relayed Tim’s derisive evaluation of Marty’s performance to the other four, all of whom agreed with the assessment. They convened a group meeting during a trip to California and confronted their lead singer. It wasn’t the first time they’d done it, but they had to try again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e263"
    }
  }, [_vm._v("“Marty, you can’t sing anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e265"
    }
  }, [_vm._v("“It wasn’t all that bad,” he insisted. “I watched it on TV.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e267"
    }
  }, [_vm._v("The band was incredulous, Brian recalls. “Jimmy or Dana said, ‘Marty, if you’re hearin’ that and thinkin’ it’s not all that bad, then you’re havin’ some serious hearing problems. "), _c('i', [_vm._v("It wasn’t all that bad? ")]), _vm._v("Dude, it was awful!’”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e272"
    }
  }, [_vm._v("The battle lines had been drawn. One of country music’s most successful and unified bands was no longer in harmony, on stage or off.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0015_002",
      "id": "d12e274",
      "src": "images/9781595552686_ePDFnf_0015_002.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e275"
    }
  }, [_vm._v("Diamond Rio’s sole lead singer, Marty Roe, was the focal point of the group’s public identity. He did more than half the interviews, he told the jokes and stories on stage, and he was the first human voice on most of their songs. To a man, the other guys loved Marty. He was the front man for the group, and his voice—more than any other element in the band—was the most identifiable sound for its fans. The slight Southern accent—acquired in his hometown of Lebanon, Ohio, a thirty-minute drive from the Kentucky border—lent a working-class authenticity to his unusually gifted abilities.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e277"
    }
  }, [_vm._v("He possessed an uncanny range in tone and in volume that allowed him to wring the emotions from a song and still maintain a decidedly masculine sound. He could sing a spiritually direct song such as “I Believe” with conviction. He could portray the personal trauma of an alcoholic’s self-inflicted pain in “You’re Gone” as if it were his own. He could get downright goofy in “How Your Love Makes Me Feel” and still maintain his dignity.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0015_005",
      "id": "d12e280",
      "src": "images/9781595552686_ePDFnf_0015_005.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e281"
    }
  }, [_c('b', [_vm._v("Marty–July 4, 2005")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e284"
    }
  }, [_vm._v("But he wasn’t making the grade. Everyone else in the group knew it, everyone "), _c('i', [_vm._v("around ")]), _vm._v("the group knew it, and it was just a matter of time before the rest of the Nashville music industry would know it as well. Marty had already taken steps to correct the problem and had made some improvements, which only goes to show how far things had fallen. The Fourth of July show had been mangled, and it was an improvement!")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d12e289"
    }
  }, [_c('b', [_vm._v("A DESPERATE LOYALTY")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e292"
    }
  }, [_vm._v("Marty had seen two vocal coaches. The band had reworked the material so that Dana sang many of Marty’s parts during the harmony sections, a move Marty found personally humiliating. Diamond Rio even employed two tuners on stage to fix his vocal errors and dropped his voice so low in the mix that many in the audience had trouble hearing him at all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e294"
    }
  }, [_vm._v("The band and its crew had taken every step possible to hide the problem, but it was now in the open. Few people outside the group had confronted Marty about it. But after the GAC special, his partners began to hear the questions from their friends and families: “You guys are too good for that.” “Are you gonna let him ruin your career?” “Are you gonna let the ship go down?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e296"
    }
  }, [_vm._v("“We had many heart-to-hearts there on the bus, the six of us just sit-tin’ there tryin’ to figure it out, Marty with his head bowed,” Dana says. “I remember sittin’ there one time sayin’, ‘Hey, man, here’s the bottom line: We all started this together, and I intend on endin’ this together. If that means this is the way it ends, then that means this is the way it ends. But I’m here to stand beside you, Marty, because the simple fact of the matter is we have stood beside one another, sung beside one another, through some of the greatest moments of my life.’ We were havin’ a real serious issue; I’ll be dogged if I’m gonna bail out then. And you know what? I was there, and I would smile and grin and make every excuse I could make, as long as he was tryin’ to make it better.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e298"
    }
  }, [_vm._v("Marty had been trying, but whatever improvement he experienced was marginal, and he had run out of ideas. The band continued to work the road steadily during the next year, playing its shell games with the sound, hoping they could dodge the issue until some "), _c('i', [_vm._v("ah-ha ")]), _vm._v("moment of inspiration led to a cure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e303"
    }
  }, [_vm._v("Finally, during the summer of 2006, Jimmy called Marty in yet another attempt to find a solution. Marty’s reaction startled the guitarist.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e305"
    }
  }, [_vm._v("“He’s tellin’ me, ‘Man, the more you’re tellin’ me about this, the more freaked out I get,’” Jimmy recalls. “This was a very emotional conversation, and we don’t have big, emotional conversations. We’re roommates on the road, but I’m not a super touchy-feely kinda guy, and neither is he.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e307"
    }
  }, [_vm._v("Marty said he would do anything Jimmy asked in order to try and regain control of his vocal talent. And then the tears began to flow. “I don’t know that I’m ever gonna get this back,” he cried. “I feel like I’ve squandered it, and it’s very possible that I’ve had my chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e310"
    }
  }, [_vm._v("As long as Marty was willing to keep trying, Jimmy was confident the band would follow him to the end. He could only see two possible conclusions: either Marty would improve, or Diamond Rio was done.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-562ce0a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rola_1595552685_epub_c8_r1.vue
// module id = 75
// module chunks = 0